let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aS39q")).then(() => parcelRequire('juT6D'));